<template>

  <div class="row">

    <loading :loadingText="`${$t('loading')}`" id="loadMe" :loadinSubText="`${$t('please_wait')}`"></loading>
  
  
  
        <div class="box" style="padding:20px">
          <div class="box-header">
            
            <h3>{{$t('location')}}</h3>
            
          </div>
           
          <!-- /.box-header -->
          <div class="box-body no-padding table-responsive">
       
          
       <form action="">
                 <div class="form-group">
     <gmap-autocomplete class="introInput form-control" :value="description" @place_changed="setPlace" >
                    <template v-slot:input="slotProps">
                        <v-text-field outlined
                                      prepend-inner-icon="place"
                                      placeholder="Location Of Event"
                                      ref="input"
                                      v-on:listeners="slotProps.listeners"
                                      v-on:attrs="slotProps.attrs">
                        </v-text-field>
                    </template>
        </gmap-autocomplete>
        <GmapMap  id="map"  @click="getPos"
  :center="center"
  :zoom="15"
  map-type-id="terrain"
  style="width:99%; height: 400px"
>
  <GmapMarker
    :key="index"
    v-for="(m, index) in markers"
    :position="m.position"
    :clickable="true"
    :draggable="true"
    @click="center=m.position" 
  />
</GmapMap>
   </div>
               	<div class="form-group">
<input type="text"  v-model="form.locationName" name="locationName"  class="form-control my-input" id="locationName" :placeholder="`${$t('locationName')}`">
</div>
	<div class="form-group">
<input type="text"  v-model="form.district" name="district"  class="form-control my-input" id="district" :placeholder="`${$t('district')}`">
</div>
	<div class="form-group">
<input type="text"  v-model="form.state" name="state"  class="form-control my-input" id="state" :placeholder="`${$t('state')}`">
</div>
	<div class="form-group">
<input type="text"  v-model="form.latitude" name="latitude"  class="form-control my-input" id="latitude" :placeholder="`${$t('latitude')}`">
</div>
	<div class="form-group">
<input type="text"  v-model="form.longitude" name="longitude"  class="form-control my-input" id="longitude" :placeholder="`${$t('longitude')}`">
</div>
                 
                  <div class="text-center" style="padding:20px">
                     <button type="button" class="btn btn-success " @click="submit">{{$t('submit')}}</button>
                  </div>
                
                  <div class="alert alert-danger padding5" v-if="error.length>0">{{error}}</div>
                  <div class="alert alert-success padding5" v-if="success.length>0"><i class="fa fa-check fa-5x text-success" aria-hidden="true"></i></div>
               </form>
            
           
           
        </div>
    </div>
 </div>

</template>

<script>
import { services } from '../../src/vuex/api'
import { mapActions , mapGetters } from 'vuex'
import simplePagination from '../../src/components/simple-pagination'
import VALoading  from '../../src/widgets/VALoading'
export default {
  name: 'AddLocation',
   mounted: function () {
      var self = this
      // var geocoder = new google.maps.Geocoder
      // var infowindow = new google.maps.InfoWindow
      /*
      let mapLibrary = this.getMap.InfoWindow
      
        if (navigator.geolocation){
            navigator.geolocation.getCurrentPosition(function(position){
                let pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                }
                this.center.lat = pos.lat
                this.center.lng = pos.lng
                this.markers[0].position.lat = pos.lat
                this.markers[0].position.lng = pos.lng
                this.setPlace(pos) // here I want to get current location address
            }.bind(this))
        }
        */
      self.getLanguage()
      if ( localStorage.getItem('lan') != null ) self.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language
    },
    data: function () {
      return {
       center: {lat: 23.8103, lng: 90.4125},
            markers: [
                {position: {lat: 10.0, lng: 10.0}}
            ],
            getMap:this.$root.mapping,
            description:'',
            latLng: {},
            place:null,
        loading:false,
        error:'',
        success:'',
        form: {
         locationName:'',
            district:'',
            state:'',
            latitude:0,
            longitude:0

        }
      }
    },
    components: {
     'loading': VALoading
     },
    methods: 
 
    {
       ...mapActions([
      'getLanguage'

    ]
       ),
   setDescription(description){
                this.description = description
            },
            getPos(e){
                var latLng_ = e.latLng
                console.log(e)
                var lat = latLng_.lat()
                var lng = latLng_.lng()
               this.latLng = {
                    lat: lat,
                    lng: lng,
                }
                // console.log(place.name)
                this.center.lat = lat
                this.center.lng = lng
                this.form.latitude = lat
                this.form.longitude =  lng
                // this.form.locationName = place.name
            },
            setPlace(place){
                // alert(place.geometry.location.lat() + "  " + place.geometry.location.lng())
                this.latLng = {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                }
                // console.log(place.name)
                this.center.lat = place.geometry.location.lat()
                this.center.lng = place.geometry.location.lng()
                this.form.latitude = place.geometry.location.lat()
                this.form.longitude = place.geometry.location.lng()
                this.form.locationName = place.name
            },
            geocodeLatLng(geocoder, map, infowindow){
                geocoder.geocode({'location':this.center}, function(results, status){
                    console.log(results, status)
                })
            }, 
  addLocation: function ( request = {} ) {
    var self = this
    self.success = ""
     $('#loadMe').modal('show')
     services.Location.addLocation(request) //  .getPatientInfo()
    .then(function (response) {
    $('#loadMe').modal('hide')
    self.success = "saved"
    })
    .catch(function (err) {
     $('#loadMe').modal('hide')
     self.error = '' + err
    })
  },
 updateLocation: function ( request = {} ) {
    var self = this
    // self.loading = true 
     $('#loadMe').modal('show')
     services.Location.updateLocation(request) //  .getPatientInfo()
    .then(function (response) {
    $('#bsModal').modal('hide')
     self.getLocation({})
    })
    .catch(function (err) {
      $('#loadMe').modal('hide')
     self.error = '' + err
    })
  },
submit:function() {
  if (this.form._id){
    this.updateLocation(this.form)
  } else {
     this.addLocation(this.form)
  }
},
 
},

 computed: {
    ...mapGetters([
      'lang'
    ])
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.users-list-row{
  margin: 10px;
  padding: 10px;
}
.input-group{
  width: 100%;
  padding: 20px;
}
.input-group-text,.input-group-select{
  width: 17%;
  margin-left: 5px;
}
.input-group-text-small{
 width: 6%;
}
.inlineDiv{
 display: inline;
}
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>

    
    


// WEBPACK FOOTER //
// AddLocation.vue?346ee462